module.exports = __webpack_public_path__ + "static/media/img-salvar-icon.78e9b7ad.svg";